var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H2V8H22V6Z",
    fill: "#B9BDC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.0526H5V13H19V11.0526Z",
    fill: "#B9BDC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H8V18H16V16Z",
    fill: "#B9BDC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyFilterIcon);
export default __webpack_public_path__ + "static/media/GreyFilterIcon.1a7683748ab518c005b49cf019139831.svg";
export { ForwardRef as ReactComponent };